export const MENU_SELECTOR = '.fancy-menu'
export const TOGGLE_SELECTOR = `${MENU_SELECTOR}-dropdown-toggle`
export const CONTENT_SELECTOR = `${MENU_SELECTOR}-content`
export const OFFCANVAS_SELECTOR = `${MENU_SELECTOR}-offcanvas`
export const DURATION = 300
